import { createFileRoute } from '@tanstack/react-router';
import DetailReportVoyagerPlanner from '@/featured/dashboard/report/detail-report-voyager-planner';
import ReportNavTabs from '@/featured/dashboard/report/ReportNavTabs';

export default function ReportVoyager() {
  return (
    <div className="w-full">
      <ReportNavTabs />
      <DetailReportVoyagerPlanner />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/report/voyager')({
  component: ReportVoyager,
});
